import  {AxiosError} from 'axios'

export interface DataProps{
    [key: string]:string|boolean|number|null|React.ReactElement|((text: string) => React.ReactNode)| undefined;
    
 
}

export interface CustomAxiosError extends Omit<AxiosError,'response'>{
    response? :{
        data:{
            error?:string
            message?:string
            status?:string
        } 
    }
}

export interface AuthTokenType{
    headers:{
        Authorization:string}
}

export interface UserType{
    email:string
    fullname:string
    id:number
    created_at:string
    role:string
    last_login:string
    
}

export interface AuthProps{
    errorCallBack?:()=>void,
    successCallBack?:()=>void,
}


export interface StoreProps{
    user:UserType | null,
    updatePasswordUserId:number|null
}

export enum ActionTypes{
    UPDATE_USER_INFO ="[action] update user info",
    UPDATE_PASSWORD_USER_ID ="[action] update password id"
}

export type ActionProps={
    type: ActionTypes.UPDATE_USER_INFO,
    payload:UserType | null
}| {
    type: ActionTypes.UPDATE_PASSWORD_USER_ID,
    payload:number | null
}

export interface StoreProviderProps{
    state:StoreProps,
    dispatch:(arg:ActionProps)=>void
}




export interface UserProps{
    created_at:string
    email:string
    fullname:string
    is_active:boolean
    last_login:string
    role:string
    key?:number
    id:number
    approved?:boolean
    denial_reason?:string
  
}
  

 
  export interface AddGroupFormModalProps{
    isVisible?:boolean
    onSuccessCallBack:()=>void
    onClose: () =>void
}

export interface AddUserFormModalProps{
    isVisible?:boolean
    onSuccessCallBack:()=>void
    onClose: () =>void
    editingUser?: UserProps | null;
    onCloseWithoutEditing:()=>void

}

// Case Management Types
export interface CaseRecordProps {
    id?: number;
    case_no: number;
    case_type?: string;
    discrimination_basis?: string;
    // Legacy fields for backward compatibility
    basis?: string; // Maps to discrimination_basis
    type?: string; // Maps to case_type
    case?: string; // Legacy classification field
    expr1?: string; // Legacy field
    expr2?: string; // Legacy field
    reason?: string; // Legacy field
    rebut?: string; // Legacy field
    reason2?: string; // Legacy field
    your_basis?: string; // Legacy field
    prevail?: string; // Legacy field
    // New model fields
    first_name?: string;
    last_name?: string;
    middle?: string;
    date_discrimination_occurred?: string;
    date_of_interview?: string;
    company_name?: string;
    accused_first_name?: string;
    accused_middle?: string;
    accused_last_name?: string;
    // Basis-specific fields (dynamic based on discrimination_basis)
    your_age?: string;
    your_color?: string;
    your_handicap?: string;
    your_national_origin?: string;
    your_race?: string;
    your_religion?: string;
    your_reprisal?: string;
    your_sex?: string;
    accused_age?: string;
    accused_color?: string;
    accused_handicap?: string;
    accused_national_origin?: string;
    accused_race?: string;
    accused_religion?: string;
    accused_reprisal?: string;
    accused_sex?: string;
    // Scoring fields
    weighted_score?: number;
    likelihood?: string;
    pdf_url?: string;
    pdf_filename?: string;
    // Metadata
    info_for_letter_date?: string;
    created_by?: number;
    created_by_name?: string;
    created_at?: string;
    updated_at?: string;
    current_stage?: string;
    is_q_letter_stage?: boolean;
    is_info_for_letter_stage?: boolean;
    // Nested relationships
    handicap_info?: any;
    accommodation_info?: any;
    coworkers_info?: any;
    responses_info?: any;
    age_info?: any;
    issues_info?: any;
    losses_info?: any;
    harassment_info?: any;
    position_info?: any;
    selectees_info?: any;
    sexual_harassment_info?: any;
    termination_info?: any;
}

// Analysis Results Types (matching new algorithm output)
export interface AnalysisResults {
    likelihood: 'High' | 'Moderate' | 'Low';
    confidence_score: number;
    reasoning: string;
    case_ref: string;
}

// Case Creation Response (includes analysis results and PDF)
export interface CaseCreationResponse extends CaseRecordProps {
    analysis_results: AnalysisResults;
    pdf_report_url?: string;
    pdf_filename?: string;
}

export interface AddCaseFormModalProps {
    isVisible?: boolean;
    onSuccessCallBack: () => void;
    onClose: () => void;
    editingCase?: CaseRecordProps | null;
    onCloseWithoutEditing: () => void;
}
 